import React from 'react'

import { Formik } from 'formik'

import { Col, Row, Button } from '_zari/core'

import AfectacionesCompraConstant from 'constants/afectacionesCompra'

import { IdGen, RounderUtil } from 'utils'

import * as FormGroups from './formGroups'

const ResumenMontosSection = ({ montosFormRef, detalles, montoPercepcionValue, importeIgvValue }) => {
  const [keyFormik, setKeyFormik] = React.useState(IdGen.newId())

  const formInitialValues = React.useMemo(() => {
    setKeyFormik(IdGen.newId())
    if (montosFormRef.current) {
      return montosFormRef.current.values || {}
    } else {

      let importeGravado = 0
      let importeIgv = importeIgvValue || 0
      let importeNoGravado = 0
      let importeOtros = 0
      let importeFlete = 0
      let importeTotal = 0
      let montoPercepcion = montoPercepcionValue || 0
      let flagPercepcion = false

      let detalle = null

      for (let i = 0; i < detalles.length; i++) {
        detalle = detalles[i]

        const innerFlete = parseFloat(detalle.flete || '0')
        const innerMontoVariante = parseFloat(detalle.subTotal) + parseFloat(detalle.isc || '0')

        importeFlete = RounderUtil.round(importeFlete + innerFlete)

        if (detalle.afectacion === AfectacionesCompraConstant.GRAVADO_A_AMBOS) {
          importeGravado = RounderUtil.round(importeGravado + innerMontoVariante)
          importeIgv = RounderUtil.round(importeIgv + detalle.igv)
        } else if (detalle.afectacion === AfectacionesCompraConstant.GRAVADO_A_GRAVADO) {
          importeGravado = RounderUtil.round(importeGravado + innerMontoVariante)
          importeIgv = RounderUtil.round(importeIgv + detalle.igv)
        } else if (detalle.afectacion === AfectacionesCompraConstant.GRAVADO_A_NO_GRAVADO) {
          importeGravado = RounderUtil.round(importeGravado + innerMontoVariante)
          importeIgv = RounderUtil.round(importeIgv + detalle.igv)
        } else if (detalle.afectacion === AfectacionesCompraConstant.NO_GRAVADO) {
          importeNoGravado = RounderUtil.round(importeNoGravado + innerMontoVariante)
        } else if (detalle.afectacion === AfectacionesCompraConstant.OTROS || detalle.afectacion === AfectacionesCompraConstant.RECIBO_HONORARIOS) {
          importeOtros = RounderUtil.round(importeOtros + innerMontoVariante)
        }
      }

      if (importeIgvValue) {
        importeIgv = importeIgvValue
      }

      importeTotal = RounderUtil.round(
        importeGravado +
        importeIgv +
        importeNoGravado +
        importeOtros +
        montoPercepcion
      )

      return {
        importeGravado,
        importeNoGravado,
        importeOtros,
        importeFlete,
        importeIgv,
        importeTotal,
        montoPercepcion,
        flagPercepcion
      }
    }

  }, [detalles, montosFormRef, montoPercepcionValue, importeIgvValue])

  return (
    <Formik key={keyFormik} initialValues={formInitialValues} innerRef={e => {
      montosFormRef.current = e
    }} >
      {({ values, handleChange, setFieldValue, isSubmitting, touched, errors }) => (
        <Row>
          <Col md={5} />
          <Col md={7}>
            <Row>
              <Col md={6}>
                {values.flagPercepcion ? (
                  <FormGroups.MontoPercepcionFormGroup
                    fIsSubmitting={isSubmitting}
                    iError={errors.montoPercepcion}
                    iTouched={touched.montoPercepcion}

                    setFieldValue={setFieldValue}
                    vTotal={values.importeTotal}
                    handleChange={handleChange}
                    iValue={values.montoPercepcion}
                  />
                ) : (
                  <Row>
                    <Col md={6} />
                    <Col md={6}>
                      <Button
                        outline
                        block
                        onClick={() => {
                          setFieldValue('flagPercepcion', true)
                          setFieldValue('montoPercepcion', 0)
                        }}
                      >
                        Percepcion
                      </Button>
                    </Col>
                  </Row>
                )}
              </Col>
              <Col md={6}>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroups.ImporteGravadoFormGroup iValue={values.importeGravado} />
                <FormGroups.ImporteNoGravadoFormGroup iValue={values.importeNoGravado} />
                <FormGroups.ImporteOtrosFormGroup iValue={values.importeOtros} />
              </Col>
              <Col md={6}>
                <FormGroups.ImporteIgvFormGroup
                  setFieldValue={setFieldValue}
                  vTotal={values.importeTotal}
                  handleChange={handleChange}
                  iValue={values.importeIgv} />
                <FormGroups.ImporteTotalFormGroup iValue={values.importeTotal} />
                <FormGroups.ImporteFleteFormGroup iValue={values.importeFlete} />
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </Formik>
  )
}

export default React.memo(ResumenMontosSection)
